export enum EmploymentSelection {
  EMPLOYMENT= 'employment',
  PROFESSION_LABEL = 'professionLabel',
  PROFESSION_KEY = 'professionKey'
}
